<template>
  <div
    v-if="isLoading || collaborators.length"
    outlined
    id="profile-recentCollaborators"
    data-tourid="profile-sheet-recentCollaborators"
  >
    <p class="subtitle2 font-weight-bold mb-4 ml-6 pt-4">
      {{ $t('profile.recently_collaborated') }}
    </p>
    <div v-if="!isLoading" class="pb-2">
      <v-list-item
        v-for="(collaborator, index) in collaborators"
        :key="collaborator.id"
        class="d-flex align-center px-4 cursor-pointer user-item"
        :class="{ 'border-top': index > 0 }"
        :to="route(collaborator)"
      >
        <UserAvatar
          data-private
          size="32px"
          fontSize="16px"
          :account="collaborator"
        />
        <div class="ml-2" style="max-width: 75%">
          <p
            class="subtitle2 blue-grey--text text--darken-2 mb-0 text-truncate"
          >
            {{ getAccountName(collaborator) }}
          </p>
          <p class="mb-0 caption blue-grey--text">
            {{ collaborator.position }}
          </p>
        </div>
      </v-list-item>
    </div>

    <div v-else>
      <div
        v-for="(collaborator, index) in 3"
        :key="collaborator.id"
        class="d-flex align-center pt-2 pb-2 px-4 cursor-pointer user-item"
        :class="{ 'border-top': index > 0 }"
      >
        <div>
          <v-skeleton-loader type="avatar" />
        </div>
        <v-skeleton-loader type="sentences" width="50%" class="ml-2" />
      </div>
    </div>
  </div>

  <EmptyState
    v-else
    data-tourid="profile-sheet-recentCollaborators"
    id="profile-recentCollaborators"
    class="py-8 px-16"
    :icon="'mdi-beehive-outline'"
    :title="$t('profile.recently_collaborated')"
    :message="$t('profile.collaborators_empty_state')"
  />
</template>
<script>
import mixin from '@/mixins/mixin.vue'
import userMixin from '@/mixins/userMixin.vue'

import UserAvatar from '@/components/UserAvatar.vue'

import EmptyState from '@/components/EmptyState.vue'

export default {
  name: 'Collaborators',
  mixins: [mixin, userMixin],

  components: {
    UserAvatar,
    EmptyState,
  },

  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    organizationId: {
      type: String,
      required: true,
    },
    collaborators: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getAccountName(account) {
      return account.nickname || this.getFullName(account)
    },
    route(account) {
      return `/profile/${this.organizationId}/${account._id}`
    },
  },
}
</script>

<style lang="scss" scoped>
.border-top {
  border-top: 1px solid $color-blue-grey-lighten2;
}
.user-item:hover {
  background-color: $color-blue-grey-lighten3;
}
</style>
